<template>
    <div>
        <rkm-area
            v-if="data.form.testesRapidosRealizados.length > 0"
            class="mb-2"
            no-margin-top
            title="Testes rapidos realizados"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col
                    v-for="(testeRapidoRealizado, index) in data.form.testesRapidosRealizados"
                    :key="index"
                    class="mb-2"
                    cols="6"
                >
                    <rkm-list-group>
                        <rkm-list-group-item class="rkm-list-group-item">
                            <rkm-row>
                                <rkm-col
                                    class="align-self-center"
                                    cols="12"
                                >
                                    <rkm-form-checkbox
                                        checked
                                        disabled
                                    >
                                        {{testeRapidoRealizado.nome}}
                                    </rkm-form-checkbox>
                                </rkm-col>
                            </rkm-row>
                        </rkm-list-group-item>
                    </rkm-list-group>

                    <rkm-collapse
                        class="rkm-collapse"
                        visible
                    >
                        <rkm-row class="p-2">
                            <rkm-col cols="12">
                                <rkm-form-textarea
                                    :value="testeRapidoRealizado.resultado"
                                    readonly
                                    rows="6"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>
            <rkm-col
                v-for="(testeRapido, index) in data.form.testesRapidos"
                :key="index"
                class="mb-2"
                cols="6"
            >
                <rkm-list-group>
                    <rkm-list-group-item class="rkm-list-group-item">
                        <rkm-row>
                            <rkm-col
                                class="align-self-center"
                                cols="12"
                            >
                                <rkm-form-checkbox
                                    :checked="!!data.model.testesRapidos.find(t => t.id === testeRapido.id)"
                                    @change.native="handleTesteRapidoChange($event, testeRapido.id)"
                                >
                                    {{testeRapido.nome}}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-list-group-item>
                </rkm-list-group>

                <rkm-collapse
                    :visible="!!data.model.testesRapidos.find(t => t.id === testeRapido.id)"
                    class="rkm-collapse"
                >
                    <rkm-row class="p-2">
                        <rkm-col cols="12">
                            <rkm-form-textarea
                                v-if="data.model.testesRapidos.find(t => t.id === testeRapido.id)"
                                :validations="validations.resultado"
                                placeholder="Resultado"
                                rows="6"
                                v-model="data.model.testesRapidos.find(t => t.id === testeRapido.id).resultado"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-collapse>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">

                <rkm-area
                    no-margin-top
                    title="Testes rápidos realizados na mesma data, durante o acolhimento."
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :items="data.form.testesRapidosUltimoAtendimento || []"
                                :fields="fields"
                                hide-filters
                                hide-pagination
                            >

                                <template v-slot:cell(nome)="{ item }">
                                    {{ item.codigo }} - {{ item.nome }}
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                resultado: {max: 500},
            }
        },
        fields() {
            return [
                { label: "Teste", key: "nome", searchable: true },
                { label: "Resultado", key: "preAtendimentoTesteRapido.resultado", searchable: true },
            ]
        }
    },
    created() {
        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleTesteRapidoChange(event, id) {
            const testeRapido = this.data.form.testesRapidos.find(testeRapido => testeRapido.id === parseInt(id))

            if (event.target.checked) {
                this.data.model.testesRapidos.push({
                    id: parseInt(id),
                    resultado: null,
                })
            } else {
                this.data.model.testesRapidos.splice(this.data.model.testesRapidos.findIndex(testeRapido => testeRapido.id === parseInt(id)) , 1)
            }

            if (testeRapido.codigo) {
                if (event.target.checked) {
                    if (!this.hasProcedimento(testeRapido.codigo)) {
                        this.insertProcedimento(testeRapido.codigo)
                    }
                } else {
                    this.deleteProcedimento(testeRapido.codigo)
                }
            }
        },
        hasProcedimento(codigo) {
            return this.data.model.procedimentosClinicos.filter(procedimentoClinico => procedimentoClinico.procedimento.codigo === codigo).length > 0
        },
        insertProcedimento(codigo) {
            this.setLoading()

            this.repositories.procedimento.index({codigo})
                .then(response => {
                    const procedimentoClinico = response.data[0]

                    this.data.model.procedimentosClinicos.push({
                        procedimento: {
                            id: procedimentoClinico.id,
                            codigo: procedimentoClinico.codigo,
                            nome: procedimentoClinico.nome,
                            hasInstrumentoRegistroRaas: !!procedimentoClinico.hasInstrumentoRegistroRaas,
                        },
                        automatico: true,
                        quantidade: 1,
                        observacao: null,
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        deleteProcedimento(codigo) {
            const index = this.data.model.procedimentosClinicos.findIndex(procedimentoClinico => procedimentoClinico.procedimento.codigo === codigo)

            if (index !== -1) {
                this.data.model.procedimentosClinicos.splice(index, 1)
            }
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>